/* eslint-disable eol-last */
import Vue from 'vue';
import Vuex from 'vuex';
import Api from '@/services/Api';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    cart: state.cart
  })
})

const vuexSession = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state) => ({
    user: state.user,
    sortOrder: state.sortOrder,
    sortProperty: state.sortProperty,
    filters: state.filters,
    facets: state.facets,
    termsAndConditions: state.termsAndConditions
  })
})

// const vuexSessionFilter = new VuexPersistence({
//     storage: window.sessionStorage,
//     reducer: (state) => ({ filters: state.filters })
// })

// const vuexSessionSortOrder = new VuexPersistence({
//     storage: window.sessionStorage,
//     reducer: (state) => ({ sortOrder: state.sortOrder })
// })

//vuex session


export default new Vuex.Store({
  state: {
    user: {
      name: '',
      language: 'en',
      languages: [],
      favoriteFilters: [],
      prices: [],
      canShareCart: false
    },
    cart: [],
    mySharedCarts: [],
    cartsSharedWithMe: [],
    token: '', // Not in use
    filters: [],
    downloads: [],
    pregeneratedCarts: [],
    newDownloads: [],
    searchString: '',
    searchList: '',
    searchSinceUtc: null,
    searchAction: false,
    sortOrder: 'desc',
    sortProperty: 'Modified',
    downloading: [],
    environments: [],
    activeEnvironment: {},
    carousels: [],
    branding: {logoUrl: '/img/logo-default.png', backgroundImageUrl: ''},
    facets: [],
    termsAndConditions: {
      documentUrl: ''
    },
    mediaFormats: [{id: "Medium", name: "Medium"}, {id: "High", name: "High"}]
  },
  getters: {
    selectedItemsForCollection: state => (collectionType) => {
      return state.cart.filter(item => item.type.toLowerCase() === collectionType.toLowerCase());
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setSearchString(state, search) {
      state.searchString = search;
    },
    setSearchList(state, list) {
      state.searchList = list;
    },
    setSearchSinceUtc(state, sinceUtc) {
      state.searchSinceUtc = sinceUtc;
    },
    setSearchAction(state, action) {
      state.searchAction = action;
    },
    setSortOrder(state, order) {
      state.sortOrder = order;
    },
    setSortProperty(state, property) {
      state.sortProperty = property;
    },
    addToCart(state, document) {
      state.cart.push(document);
    },
    setUserSharedCarts(state, carts) {
      state.mySharedCarts = carts;
    },
    setSharedWithUserCarts(state, carts) {
      state.cartsSharedWithMe = carts;
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
    },
    clearCart(state) {
      state.cart = [];
    },
    removeFromCart(state, document) {
      let obj = state.cart.find(obj => obj.id === document.id);

      if (obj !== undefined) {
        var index = state.cart.indexOf(obj);
        state.cart.splice(index, 1);
      }
    },
    addFilter(state, filter) {
      state.filters.push(filter);
    },
    setFilters(state, filters) {
      state.filters = filters;
    },
    replaceFavoriteFilters(state, filters) {
      state.user.favoriteFilters = filters;
    },
    clearFilters(state) {
      state.filters = [];
    },
    removeFilter(state, filter) {
      var index = state.filters.indexOf(filter);

      if (index > -1) {
        state.filters.splice(index, 1);
      }
    },
    addDownload(state, download) {
      state.downloads.unshift(download);
    },
    setDownloads(state, downloads) {
      state.downloads = downloads.filter((download) => !download.pregenerated);
      state.pregeneratedCarts = downloads.filter((download) => download.pregenerated);
    },
    setTermsAndConditions(state, conditions) {
      state.termsAndConditions = conditions;
    },
    setMediaFormats(state, formats) {
      state.mediaFormats = formats;
    },
    setBranding(state, branding) {
      state.branding = branding;
    },
    setFacets(state, facets) {
      state.facets = facets;
    },
    setUserEnvironments(state, environments) {
      state.environments = environments;
    },
    setActiveEnvironment(state, environment) {
      state.activeEnvironment = environment;
    },
    setLanguages(state, environment) {
      state.user.languages = environment.languages;
    },
    setCarousels(state, carousels) {
      state.carousels = carousels;
    },
    addDownloading(state, download) {
      state.downloading.unshift(download);
    },
    addMultipleDownloading(state, downloads) {
      state.downloading = downloads;
    },
    addNewDownload(state, download) {
      state.newDownloads.unshift(download);
    },
    clearNewDownloads(state, downloads) {
      state.newDownloads = downloads;
    },
    removeFromDownloading(state, download) {
      let obj = state.downloading.find(obj => obj.id === download.id);

      if (obj !== undefined) {
        var index = state.downloading.indexOf(obj);
        state.downloading.splice(index, 1);
      }
    }
  },
  actions: {
    getUser({
              commit
            }) {
      Api().get('/user/environments/' + this.state.activeEnvironment.id).then(response => commit('setUser', response.data.result));
    },
    getUserEnvironments({
                          commit
                        }) {
      Api().get('/user/environments/all')
        .then(response => commit(
          'setUserEnvironments',
          response.data.filter(environment => environment.id !== this.state.activeEnvironment.id)));
    },
    async getActiveEnvironment({
                                 commit
                               }) {
      await Api().get('/user/environments/active').then(response => { 
        commit('setActiveEnvironment', response.data.result);
        if(response.data.result.closed === true){
          window.location = '/#/environment-closed';
        }
      }).catch(error => {
          window.location = '/#/usernotfound';
      });
    },
    getDownloadFormats({
                         commit
                       }) {
      Api().get('user/mediaformats').then(response => commit('setMediaFormats', response.data.result));
    },
    persistUserFavoriteFilters({
                                 commit
                               }) {
      Api().post('/api/v2/user').then(response => commit('setUser', response.data.result));
    },
    loadCustomerBranding({
                           commit
                         }) {
      Api().get('/api/v2/user/branding').then(response => commit('setBranding', response.data.result));
    },
    loadCustomerFacets({
                         commit
                       }) {
      Api().get('user/facets').then(response => commit('setFacets', response.data.result));
    },
    loadInitialState({
                       commit
                     }) {
      Api().get('/user/downloads').then(response => commit('setDownloads', response.data.result));
    },
    loadCarousels({
                    commit,
                    state
                  }) {
      Api().get('/carousels/' + state.activeEnvironment.id).then(response => commit('setCarousels', response.data));
    },
    loadUserSharedCarts({
                          commit
                        }) {
      Api().get('/sharedcarts').then(response =>{
        commit('setUserSharedCarts', response.data.result.sharedByUserCarts);
        commit('setSharedWithUserCarts', response.data.result.sharedWithUserCarts);
      });
    },
    getTermsAndConditions({
                            commit,
                            state
                          }) {
      Api().get('/termsAndConditions/' + state.activeEnvironment.id).then(response => commit('setTermsAndConditions', response.data.result));
    }
  },
  plugins: [vuexSession.plugin, vuexLocal.plugin]
});
